/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { extend, defaults, delay } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { VirtualScrollbar } from './virtual-scrollbar';

const SCROLLBAR_HEIGHT = 17;
const MARGIN_RIGHT = 17;
const VIRTUAL_SCROLLBAR_HEIGHT = 14;

const getTablePageStyles = () => extend({
  scrollBarView: {
    marginRight: MARGIN_RIGHT,
    overflow: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

class UnStyledScrollbar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.unmounted = false;
    this.pgridView = props.pgridView;
    this.state = { bottom: '0', positionStatic: false };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    if (this.props.pgridView) {
      const $table = this.props.pgridView.$el.find('.table-container');
      if ($table.length > 0) {
        delay(() => {
          if (this.unmounted) {
            return;
          }

          let bottom;
          let positionStatic;
          const $tfoot = $table.find('tfoot');

          if ($tfoot && $tfoot.offset().top !== 0) { // if tfoot visible
            bottom = $tfoot.height() - VIRTUAL_SCROLLBAR_HEIGHT;
          } else {
            bottom = 'auto';
          }
          if ($tfoot.children().length === 0) { // if tfoot has no child
            positionStatic = 'static';
          }

          if (bottom !== this.state.bottom || this.state.positionStatic !== positionStatic) {
            this.setState({ bottom, positionStatic });
          }
        }, 100);
      }
    }

    const fixedBottomOffset = this.props.containerOverflowX ? SCROLLBAR_HEIGHT : 0;

    const parentStyle = defaults(
      { display: this.props.shouldDisplay ? 'block' : 'none' },
      { position: this.props.positionFixed ? 'fixed' : this.state.positionStatic ? 'static' : 'absolute' },
      { bottom: this.props.positionFixed ? fixedBottomOffset : this.state.bottom },
      { width: this.props.width }
    );

    return (
      <VirtualScrollbar
        style={parentStyle}
        height={VIRTUAL_SCROLLBAR_HEIGHT}
        width={this.props.width}
        viewWidth={this.props.gridViewWidth + this.props.gridPaddingLeft + MARGIN_RIGHT}
      >
        <div className={this.props.classes.scrollBarView}>
          {this.props.children}
        </div>
      </VirtualScrollbar>
    );
  }
}

UnStyledScrollbar.propTypes = {
  children: PropTypes.object.isRequired,
  pgridView: PropTypes.object,
  classes: PropTypes.object.isRequired,
  shouldDisplay: PropTypes.bool,
  positionFixed: PropTypes.bool,
  gridViewWidth: PropTypes.number,
  width: PropTypes.number,
  containerOverflowX: PropTypes.bool,
  gridPaddingLeft: PropTypes.number,
};

UnStyledScrollbar.defaultProps = {
  pgridView: null,
  shouldDisplay: false,
  positionFixed: false,
  gridViewWidth: 0,
  width: 0,
  containerOverflowX: false,
  gridPaddingLeft: 32,
};

export const Scrollbar = withDefaultStyles(UnStyledScrollbar, getTablePageStyles);
